import React from 'react';
import { FormattedMessage } from 'react-intl';

var UMBRAL_ROJO_SFTP_HORAS  = 12;
var UMBRAL_ROJO_CRON_HORAS  = 2;

var COLOR = {
    verde:   '#28A745',
    naranja: '#FFA500',
    rojo:    '#DC3545',
};

var styles = {
    contenedor: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 16px',
        marginBottom: '4px',
        cursor: 'default',
    },
    dot: {
        width: '9px',
        height: '9px',
        borderRadius: '50%',
        marginRight: '8px',
        flexShrink: 0,
    },
    texto: {
        fontFamily: "'Poppins', sans-serif",
        fontSize: '14px',
        fontWeight: 400,
        color: '#6B6F82',
    },
};

function calcularEstado(t1, t2) {
    if (!t1 || !t2) return 'rojo';

    var msT1  = new Date(t1).getTime();
    var msT2  = new Date(t2).getTime();

    if (isNaN(msT1) || isNaN(msT2)) return 'rojo';

    var ahora            = Date.now();
    var diffAhoraT1Horas = (ahora - msT1) / 3600000;
    var diffT1T2Horas    = (msT1 - msT2) / 3600000;

    if (diffAhoraT1Horas > UMBRAL_ROJO_SFTP_HORAS)  return 'rojo';
    if (diffT1T2Horas    > UMBRAL_ROJO_CRON_HORAS)   return 'rojo';
    if (diffT1T2Horas    > 0)                         return 'naranja';
    return 'verde';
}

function formatFecha(isoString) {
    if (!isoString) return '-';
    var d = new Date(isoString);
    if (isNaN(d.getTime())) return '-';
    var yyyy = d.getFullYear();
    var mm   = String(d.getMonth() + 1).padStart(2, '0');
    var dd   = String(d.getDate()).padStart(2, '0');
    var hh   = d.getHours();
    var min  = String(d.getMinutes()).padStart(2, '0');
    return yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + min;
}

function UltimaActualizacion(props) {
    var t1     = props.inicioProceso;
    var t2     = props.finProceso;
    var estado = calcularEstado(t1, t2);

    return (
        <div style={styles.contenedor}>
            <span style={Object.assign({}, styles.dot, { backgroundColor: COLOR[estado] })} />
            <span style={styles.texto}>
                <FormattedMessage
                    id="disponibilidad.leyenda.recepcion_rutas"
                    defaultMessage="Última recepción de Rutas"
                />
                {': ' + formatFecha(t1) + ' - '}
                <FormattedMessage
                    id="disponibilidad.leyenda.sincronizacion_disponibilidad"
                    defaultMessage="Última sincronización de Disponibilidad"
                />
                {': ' + formatFecha(t2)}
            </span>
        </div>
    );
}

export default UltimaActualizacion;
